import React from 'react';
import { BrochureLayout } from './components/BrochureLayout';
export function App() {
  return <BrochureLayout data-id="element-0" />;
}